// extracted by mini-css-extract-plugin
module.exports = {"root":"p4lev","TextSeparatorsMenuButtonNSkin":"_3o8r-","textSeparatorsMenuButtonNSkin":"_3o8r-","linkElement":"_Fkfh","label":"_3pBZ3","wrapper":"_1AawS"};